import React from "react";

const Cyber = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Cybersecurity & Tools</h3>
      <div className="skills__box">
        


        <div className="skills__group">
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Network Security</h3>
              {/* <span className="skills__level">Intermediate</span> */}
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Vulnerability Management</h3>
              {/* <span className="skills__level">Intermediate</span> */}
            </div>
          </div>
          
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Penetration Testing</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Vulnerability Assessment</h3>
            </div>
          </div>

             
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Principles of Cybersecurity</h3>
              {/* <span className="skills__level">Intermediate</span> */}
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Incident Response</h3>
              {/* <span className="skills__level">Basic</span> */}
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Networking Knowledge</h3>
              {/* <span className="skills__level">Intermediate</span> */}
            </div>
          </div>

          
        </div>
      </div>
    </div>
  );
};

export default Cyber;
